import { useServiceReportQuery } from '@/dealers/_gen/gql'

type Options = Parameters<typeof useServiceReportQuery>[0]

// Drops quotes whose creation is null — exactly the set of Order Now
// (buyer-submitted) quotes, which nobody quoted, so they don't belong in
// a service report. Every quoted request has a creation, credited to the
// rep or to Gearflow Automation.
const useQuery = (options: Options) => {
  const { data } = useServiceReportQuery(options)

  const rfqs = data?.rfqs.flatMap((rfq) =>
    rfq.quote && rfq.quote.creation ? { ...rfq, quote: rfq.quote } : []
  )

  const comparisonRfqs = data?.comparisonRfqs.flatMap((rfq) =>
    rfq.quote && rfq.quote.creation ? { ...rfq, quote: rfq.quote } : []
  )

  return { rfqs, comparisonRfqs }
}

type Result = ReturnType<typeof useQuery>

export type Rfq = Exclude<Result['rfqs'], undefined>[number]

export type ComparisonRfq = Exclude<Result['comparisonRfqs'], undefined>[number]

// A customer can have no organization (GEA-4987); `orgById` only ever holds the
// real ones, so `Org` itself stays non-null.
export type Org = NonNullable<Rfq['quote']['customer']['organization']>

export type Creator = NonNullable<Rfq['quote']['creation']>['creator']

export default useQuery
